import React from "react";

export const HeartFilledIcon = (props) => {
  return (
    <svg
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.8398 12.3299L13.012 23L2.18431 12.3299C1.47012 11.6384 0.907564 10.8072 0.532066 9.88876C0.156568 8.97031 -0.0237372 7.98445 0.00250318 6.99325C0.0287436 6.00206 0.260962 5.02701 0.684534 4.1295C1.10811 3.23199 1.71386 2.43147 2.46364 1.77834C3.21343 1.12521 4.091 0.633624 5.04111 0.334538C5.99122 0.0354525 6.99327 -0.0646541 7.98417 0.0405211C8.97507 0.145696 9.93335 0.453875 10.7987 0.945652C11.664 1.43743 12.4176 2.10215 13.012 2.89796C13.609 2.10793 14.3635 1.44901 15.2282 0.962456C16.093 0.475899 17.0493 0.172171 18.0374 0.0702828C19.0256 -0.0316056 20.0242 0.0705386 20.9708 0.370322C21.9174 0.670106 22.7917 1.16108 23.5388 1.8125C24.286 2.46393 24.8899 3.26179 25.3129 4.15616C25.7359 5.05052 25.9688 6.02212 25.9971 7.01017C26.0253 7.99821 25.8483 8.98142 25.4771 9.89826C25.1059 10.8151 24.5485 11.6458 23.8398 12.3385"
        fill="currentColor"
      />
    </svg>
  );
};
